import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Pager, Button, EmptyItem } from "rhombus-react";
import { CreativePreviews, loadCreativePreviews } from "reducers/CreativePreviews";
import { useCollectionFiltering } from "utils/DataGrid";
import { CREATIVE_ROW_COUNT_OPTIONS } from "utils/constants";
import useCancelToken from "hooks/useCancelToken";
import Toolbar from "routes/previews/Toolbar";
import Grid from "./Grid";

import "./PreviewGrid.css";

export default function PreviewGrid({ libraryId }) {
	const {
			creativePreviewsState,
			previews,
			totalPages,
			totalItems,
			isLoading,
		} = useSelector((state) => {
			return {
				creativePreviewsState: state.creativePreviews,
				totalPages: state.creativePreviews.totalPages,
				totalItems: state.creativePreviews.totalItems,
				isLoading: state.creativePreviews.isLoading,
				previews: state.creativePreviews.items,
			};
		})
		, dispatch = useDispatch()
		;

	const { getNewToken } = useCancelToken(true);

	useEffect(() => {
		dispatch(loadCreativePreviews(libraryId));
	}, [libraryId]);

	const {
		filterInfo: { page, rpp, searchTerm, sort },
	} = useCollectionFiltering(
		creativePreviewsState,
		CreativePreviews.setAdvancedFilter,
		() => {
			dispatch(CreativePreviews.clearCreativePreviews()).then(() => {
				dispatch(CreativePreviews.loadCreativePreviews(libraryId, getNewToken()));
			});
		}
	);

	const handleSearch = newSearchTerm => dispatch(CreativePreviews.setSearchTerm(newSearchTerm));

	const pagerProps={
		showItemCount: true,
		initialPage: page,
		forcePage: page,
		pageSize: rpp,
		pageCount: totalPages,
		maxItems: totalItems,
		showItemWord: "",
		rowCountItems: CREATIVE_ROW_COUNT_OPTIONS,
		disabled: isLoading,

		onPageChange: newPage => dispatch(CreativePreviews.setPage(newPage)),
		onRowCountChange: newRPP => dispatch(CreativePreviews.setRPP(newRPP)),
	};

	let emptyProps = null;
	if (previews.length === 0 && !isLoading) {
		if (searchTerm) {
			emptyProps = {
				className: "empty-previews no-search-results",
				title: "No search results to display",
				message: "Try adjusting your search to find what you are looking for",
				src: "/images/noSearch.svg",
				buttons: <Button key="clear" onClick={() => dispatch(CreativePreviews.setSearchTerm(""))}>Clear Search</Button>,
			};
		}
	}

	return (
		<div className="preview-grid">
			<Toolbar
				key="toolbar"
				searchValue={searchTerm}
				isLoading={isLoading}
				onSearch={handleSearch}
			/>
			{ emptyProps ? <EmptyItem {...emptyProps} /> : <Grid libraryId={libraryId} sort={sort} isLoading={isLoading} /> }
			<Pager key="pager" { ...pagerProps } />
		</div>
	);
}

PreviewGrid.displayName = "PreviewGrid";
